<template>
  <div>
    <el-container v-if="!isLogin">
      <el-main>
        <headerTop></headerTop>
        <div class="main-container">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
    <el-container v-if="isLogin">
        <router-view />
    </el-container>
  </div>
 
</template>
<script>
import headerTop from "./components/public/top_header.vue";
export default {
  data() {
    return {
      isLogin:false,
    };
  },
  components: {
    headerTop,
  },
  watch: {
		$route(to) {
			this.change(to)
		},
		
	},
  async mounted() { 
    this.change()
    
   },
  methods:{
    change(){
        let e = this.$route
        this.isLogin = e.meta.hideMenu !== undefined || e.name === null
    },
    
    
  }
};
</script>
